export default __webpack_public_path__ + "static/wave-dda836866b7e63dd60008ea8a01e991b.mp4";